import styled from '@emotion/styled';
import React from 'react';

export type StyledNavProps = React.HTMLAttributes<HTMLDivElement>;

const StyledNav = styled.nav<StyledNavProps>({
  a: {
    textDecoration: 'none'
  }
});

export default StyledNav;
